import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar"
import { AppSidebar } from "./AppSidebar"
import { Outlet, useLocation, useNavigate } from "react-router"
import { Toaster } from "sonner"
import { getNavItem } from "./nav"
import { clearAuthSession, getAuthUser } from "@/utils/auth"
import { Avatar, Dropdown, type MenuProps } from "antd"
import { DownOutlined, LogoutOutlined, UserOutlined } from "@ant-design/icons"

export default function Layout() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const currentItem = getNavItem(pathname)
  const currentUser = getAuthUser()

  const handleLogout = () => {
    clearAuthSession()
    navigate("/login", { replace: true })
  }

  const menuItems: MenuProps["items"] = [
    {
      key: "profile",
      label: (
        <div className="py-1">
          <div className="text-sm font-medium text-foreground">
            {currentUser?.name || "未登录"}
          </div>
          <div className="text-xs text-muted-foreground">{currentUser?.code || "-"}</div>
        </div>
      ),
      disabled: true,
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "退出登录",
      onClick: handleLogout,
    },
  ]

  return (
    <SidebarProvider>
      <AppSidebar />
      <main className="flex h-svh min-w-0 flex-1 flex-col overflow-hidden">
        <header className="z-20 shrink-0 border-b bg-background/80 backdrop-blur">
          <div className="flex items-center justify-between gap-3 px-6 py-4">
            <SidebarTrigger />
            <div className="min-w-0 flex-1">
              <h1 className="truncate text-lg font-semibold text-foreground">
                {currentItem?.title ?? "管理后台"}
              </h1>
            </div>
            <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
              <button
                type="button"
                className="inline-flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm hover:bg-accent/40"
              >
                <Avatar size={24} icon={<UserOutlined />} />
                <span className="max-w-28 truncate">
                  {currentUser?.name || "未登录"}
                </span>
                <DownOutlined className="text-xs text-muted-foreground" />
              </button>
            </Dropdown>
          </div>
        </header>
        <div className="flex min-h-0 flex-1 overflow-x-hidden overflow-y-auto">
          <div className="min-w-0 flex-1">
            <Outlet />
          </div>
        </div>
      </main>
      <Toaster position="top-center" richColors />
    </SidebarProvider>
  )
}
